import { render } from "./GraphicDesign.vue?vue&type=template&id=41b31204&scoped=true"
import script from "./GraphicDesign.vue?vue&type=script&lang=js"
export * from "./GraphicDesign.vue?vue&type=script&lang=js"

import "./GraphicDesign.vue?vue&type=style&index=0&id=41b31204&scoped=true&lang=css"

import exportComponent from "G:\\BWD\\BWD-NEW-05-04-2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41b31204"]])

export default __exports__